import type { CarrierShipmentConfigResponse } from './api';

export const normalizeCarrierShipmentConfig = (list: CarrierShipmentConfigResponse): Record<string, boolean> => {
  if (!list) {
    return {};
  }
  return Object.fromEntries(list.map((item) => [item.columnName, Boolean(item.isVisible)]));
};
